(function(){
  function mark(){
    if(document.body) document.body.classList.add('saratti-collection-active');
  }

  function getFilterColumn(){
    return document.querySelector('.main-products-grid__filters');
  }

  function getToolbar(){
    return document.querySelector('products-toolbar.products-toolbar, .products-toolbar');
  }

  function isElementVisible(el){
    if(!el) return false;
    var style = window.getComputedStyle(el);
    if(style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 20 && rect.height > 20 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function isHeaderNavigationOpen(){
    var header = document.querySelector('store-header, .cc-header, .header');
    if(!header) return false;

    var headerRect = header.getBoundingClientRect();

    if(window.innerWidth <= 768){
      var mobileMenu = header.querySelector('.main-menu__content');
      if(isElementVisible(mobileMenu)){
        var mobileRect = mobileMenu.getBoundingClientRect();
        if(mobileRect.height > 150 && mobileRect.bottom > headerRect.bottom + 70) return true;
      }
    }

    var panels = header.querySelectorAll('.main-nav__child, .mega-nav, .child-nav--dropdown');
    for(var i = 0; i < panels.length; i += 1){
      var panel = panels[i];
      if(!isElementVisible(panel)) continue;
      var rect = panel.getBoundingClientRect();
      if(rect.height > 80 && rect.bottom > headerRect.bottom + 70) return true;
    }

    return false;
  }

  function syncHeaderNavigationState(){
    if(!document.body) return;
    document.body.classList.toggle('saratti-nav-menu-active', isHeaderNavigationOpen());
  }

  function ensureHelperStyle(){
    if(document.getElementById('saratti-collection-helper-style')) return;
    var style = document.createElement('style');
    style.id = 'saratti-collection-helper-style';
    style.textContent = [
      'body.saratti-filter-soft-closed .main-products-grid__filters{display:none!important;}',
      'body.template-collection .products-toolbar,body.saratti-collection-active .products-toolbar,body.template-collection products-toolbar.products-toolbar,body.saratti-collection-active products-toolbar.products-toolbar{z-index:30!important;}',
      '@media(max-width:768px){body.template-collection .products-toolbar,body.saratti-collection-active .products-toolbar,body.template-collection products-toolbar.products-toolbar,body.saratti-collection-active products-toolbar.products-toolbar{z-index:30!important;}}',
      'body.saratti-nav-menu-active .products-toolbar,body.saratti-nav-menu-active products-toolbar.products-toolbar{display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;}',
      'body.template-collection .facets .facets__footer::before,body.saratti-collection-active .facets .facets__footer::before{display:none!important;content:none!important;}',
      'body.template-collection .facets .facets__footer,body.saratti-collection-active .facets .facets__footer{display:grid!important;grid-template-columns:1fr 1fr!important;gap:14px!important;align-items:center!important;}',
      'body.template-collection .facets .saratti-footer-clear-all,body.saratti-collection-active .facets .saratti-footer-clear-all{height:54px!important;display:flex!important;align-items:center!important;justify-content:center!important;border:1px solid rgba(17,24,39,.13)!important;background:#fff!important;color:#111827!important;text-decoration:none!important;font-size:10px!important;line-height:1!important;letter-spacing:.18em!important;font-weight:700!important;text-transform:uppercase!important;box-sizing:border-box!important;cursor:pointer!important;}',
      'body.template-collection .facets .drawer__footer .btn,body.saratti-collection-active .facets .drawer__footer .btn{display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;white-space:normal!important;cursor:pointer!important;user-select:none!important;}',
      '@media(max-width:768px){body.template-collection .facets .facets__footer,body.saratti-collection-active .facets .facets__footer{grid-template-columns:1fr 1fr!important;gap:12px!important;}body.template-collection .facets .saratti-footer-clear-all,body.saratti-collection-active .facets .saratti-footer-clear-all{height:52px!important;font-size:9px!important;letter-spacing:.16em!important;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function removeFilterOverlay(){
    if(document.body){
      document.body.classList.remove('saratti-filter-open');
      document.body.style.removeProperty('overflow');
    }
  }

  function softOpenFilterDrawer(){
    if(document.body) document.body.classList.remove('saratti-filter-soft-closed');
  }

  function softCloseFilterDrawer(){
    if(document.body) document.body.classList.add('saratti-filter-soft-closed');
    removeFilterOverlay();
  }

  function isFilterColumnVisible(filterCol){
    if(!filterCol) return false;
    if(document.body && document.body.classList.contains('saratti-filter-soft-closed')) return false;
    if(filterCol.hidden) return false;
    if(filterCol.classList.contains('lg:js-hidden')) return false;
    var style = window.getComputedStyle(filterCol);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function forceOpenFilterDrawer(){
    var filterCol = getFilterColumn();
    if(!filterCol) return;
    softOpenFilterDrawer();
    filterCol.hidden = false;
    filterCol.removeAttribute('hidden');
    filterCol.classList.remove('lg:js-hidden');
    filterCol.classList.remove('js-hidden');
    filterCol.style.removeProperty('display');
    filterCol.style.removeProperty('visibility');
    filterCol.style.removeProperty('opacity');
    var drawer = filterCol.querySelector('.facets.drawer, facet-filters, .drawer');
    if(drawer){
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden','false');
      drawer.style.removeProperty('display');
      drawer.style.removeProperty('visibility');
      drawer.style.removeProperty('transform');
      drawer.classList.remove('is-closing');
      drawer.classList.add('is-open');
    }
    if(document.body){
      document.body.classList.add('saratti-filter-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function syncFilterOverlay(){
    var filterCol = getFilterColumn();
    if(isFilterColumnVisible(filterCol)){
      if(document.body) document.body.classList.add('saratti-filter-open');
    }else{
      removeFilterOverlay();
    }
  }

  function visibleGridProductCount(){
    var grid = document.querySelector('.main-products-grid__results .grid');
    if(!grid) return 0;
    return grid.querySelectorAll('li.js-pagination-result .card--product, li.js-pagination-result product-card').length;
  }

  function drawerResultCount(){
    var btn = document.querySelector('.main-products-grid__filters .drawer__footer .btn');
    var text = btn ? (btn.textContent || '') : '';
    var match = text.match(/(\d[\d,]*)\s+(result|item|product)/i);
    return match ? match[1].replace(/,/g,'') : '';
  }

  function activeFilterCount(){
    var params = new URLSearchParams(window.location.search || '');
    var count = 0;
    params.forEach(function(value,key){
      if(key.indexOf('filter.') === 0 && value !== '') count += 1;
    });
    if(count > 0) return count;
    var active = document.querySelectorAll('.active-filters a, .active-filters__remove, .facets__active a, .facet-filters__active a');
    return active ? active.length : 0;
  }

  function hasActiveSort(){
    var params = new URLSearchParams(window.location.search || '');
    return params.has('sort_by') && params.get('sort_by') !== '';
  }

  function getCountText(){
    var hasFilters = activeFilterCount() > 0;
    var fromDrawer = drawerResultCount();
    var visibleCount = visibleGridProductCount();
    var holder = document.querySelector('.container[data-num-results]');
    var originalCount = holder ? holder.getAttribute('data-num-results') : '';
    var count = '';
    if(hasFilters && fromDrawer) count = fromDrawer;
    else if(hasFilters && visibleCount) count = String(visibleCount);
    else count = originalCount || fromDrawer || (visibleCount ? String(visibleCount) : '');
    return count ? count + ' PRODUCTS' : '';
  }

  function updateToolbarState(){
    var toolbar = getToolbar();
    if(!toolbar) return;
    toolbar.classList.toggle('has-active-filters', activeFilterCount() > 0);
    toolbar.classList.toggle('has-active-sort', hasActiveSort());
  }

  function ensureToolbarCount(){
    var toolbar = getToolbar();
    if(!toolbar) return;
    toolbar.classList.add('saratti-toolbar-final');
    var count = toolbar.querySelector('.saratti-toolbar-count');
    if(!count){
      count = document.createElement('span');
      count.className = 'saratti-toolbar-count';
      toolbar.appendChild(count);
    }
    var text = getCountText();
    if(text) count.textContent = text;
    updateToolbarState();
  }

  function getClearAllHref(){
    var nativeClear = document.querySelector('.main-products-grid__filters .js-clear-all, .main-products-grid__filters .active-filters a[href]');
    if(nativeClear && nativeClear.getAttribute('href')) return nativeClear.getAttribute('href');
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function(key){
      if(key.indexOf('filter.') === 0 || key === 'page') url.searchParams.delete(key);
    });
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
  }

  function ensureDrawerFooterActions(){
    var footer = document.querySelector('.main-products-grid__filters .facets__footer');
    if(!footer) return;
    var clear = footer.querySelector('.saratti-footer-clear-all');
    if(!clear){
      clear = document.createElement('a');
      clear.className = 'saratti-footer-clear-all js-clear-all';
      clear.textContent = 'CLEAR ALL';
      footer.insertBefore(clear, footer.firstChild);
    }
    clear.setAttribute('href', getClearAllHref());
    var show = footer.querySelector('.drawer__footer .btn, .btn');
    if(show){
      show.setAttribute('type','button');
      show.classList.add('saratti-footer-show-results');
    }
  }

  function bindFilterBehavior(){
    if(document.documentElement.dataset.sarattiFilterBehaviorBound === 'true') return;
    document.documentElement.dataset.sarattiFilterBehaviorBound = 'true';

    document.addEventListener('click', function(e){
      if(e.target.closest('.products-toolbar__filter-btn')){
        softOpenFilterDrawer();
        setTimeout(syncFilterOverlay, 60);
        setTimeout(function(){
          var filterCol = getFilterColumn();
          if(window.innerWidth <= 768 && !isFilterColumnVisible(filterCol)) forceOpenFilterDrawer();
          ensureDrawerFooterActions();
          syncFilterOverlay();
        }, 180);
        setTimeout(function(){ ensureDrawerFooterActions(); syncFilterOverlay(); }, 420);
        return;
      }

      var clearAll = e.target.closest('.main-products-grid__filters .saratti-footer-clear-all');
      if(clearAll){
        var href = clearAll.getAttribute('href') || getClearAllHref();
        if(href){ e.preventDefault(); window.location.href = href; }
        return;
      }

      if(e.target.closest('.main-products-grid__filters .drawer__close-btn, .main-products-grid__filters .js-close-drawer, .main-products-grid__filters .js-close-drawer-mob, .main-products-grid__filters .drawer__footer .btn')){
        setTimeout(softCloseFilterDrawer, 120);
        setTimeout(function(){ ensureToolbarCount(); updateToolbarState(); }, 450);
      }
    }, false);

    document.addEventListener('change', function(e){
      if(e.target && e.target.closest('.main-products-grid__filters') && e.target.matches('input[type="checkbox"], input[type="radio"], select')){
        softOpenFilterDrawer();
        if(document.body) document.body.classList.add('saratti-filter-open');
        setTimeout(function(){ ensureDrawerFooterActions(); ensureToolbarCount(); updateToolbarState(); }, 300);
        setTimeout(syncFilterOverlay, 650);
      }
    }, false);

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') setTimeout(softCloseFilterDrawer, 80);
    });
  }

  function bindHeaderNavigationState(){
    if(document.documentElement.dataset.sarattiHeaderNavStateBound === 'true') return;
    document.documentElement.dataset.sarattiHeaderNavStateBound = 'true';
    ['click','mouseover','mouseout','focusin','focusout','touchstart','keydown'].forEach(function(eventName){
      document.addEventListener(eventName, function(){
        setTimeout(syncHeaderNavigationState, 40);
        setTimeout(syncHeaderNavigationState, 220);
        setTimeout(syncHeaderNavigationState, 520);
      }, true);
    });
    document.addEventListener('toggle', function(){
      setTimeout(syncHeaderNavigationState, 40);
      setTimeout(syncHeaderNavigationState, 220);
    }, true);
    window.addEventListener('resize', function(){ setTimeout(syncHeaderNavigationState, 80); });
    window.addEventListener('scroll', function(){ setTimeout(syncHeaderNavigationState, 40); }, {passive:true});
  }

  function init(){
    mark();
    ensureHelperStyle();
    ensureToolbarCount();
    ensureDrawerFooterActions();
    bindFilterBehavior();
    bindHeaderNavigationState();
    setTimeout(syncFilterOverlay, 0);
    setTimeout(syncHeaderNavigationState, 0);
    setTimeout(function(){ ensureToolbarCount(); updateToolbarState(); ensureDrawerFooterActions(); syncHeaderNavigationState(); }, 150);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('on:facet-filters:updated', function(){
    init();
    setTimeout(function(){ ensureToolbarCount(); updateToolbarState(); ensureDrawerFooterActions(); syncHeaderNavigationState(); }, 250);
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('on:custom-pagination:loaded', function(){ setTimeout(ensureToolbarCount, 120); });
  document.addEventListener('on:pagination:loaded', function(){ setTimeout(ensureToolbarCount, 120); });
  document.addEventListener('on:products:loaded', function(){ setTimeout(ensureToolbarCount, 120); });
  document.addEventListener('click', function(e){
    if(e.target.closest('.js-pagination-load-more')){
      setTimeout(ensureToolbarCount, 800);
      setTimeout(ensureToolbarCount, 1800);
    }
  });

  if(document.readyState !== 'loading') init();
})();
